import _ from 'lodash';
import { createSelector } from 'reselect';

import { createMap } from 'Common/Helpers/format';
import { makeOptionsData } from 'Common/FormHelper';

const root = state => _.get(state, 'Provision2');

export const getLoadingSites = state =>
  _.get(root(state), 'loadingSites', false);

export const getError = state => _.get(root(state), 'error');

export const getServedItems = state => _.get(root(state), 'servedItems', []);
export const getLoadingServedItems = state =>
  _.get(root(state), 'loadingServedItems', false);

export const getServedItemOptions = createSelector(
  getServedItems,
  servedItems =>
    makeOptionsData(servedItems, {
      keyKey: 'ItemId',
      valueKey: 'ItemId',
      textKeys: ['ItemId', 'Description'],
    })
);

export const getServedItemsMap = createSelector(
  getServedItems,
  servedItems => createMap(servedItems, 'ItemId')
);

export const getLoadingCalculation = state =>
  _.get(root(state), 'loadingCalculation', false);

export const getLoadingWriteMeals = state =>
  _.get(root(state), 'loadingWriteMeals', false);

export const getWriteError = state => _.get(root(state), 'writeError', null);

export const getWriteSuccessful = state =>
  _.get(root(state), 'writeSuccessful', false);



// WEBPACK FOOTER //
// ./src/pages/provision2/state/selectors.js